import { Badge } from '@pesto/ui/components/Badge';
import { Card } from '@pesto/ui/components/Card';
import { Typography } from '@pesto/ui/components/Typography';
import { ChevronRight } from 'lucide-react';

import type { LinkedEntityCardProps } from '../types/LinkedEntityCard.types';

export const LinkedEntityCard = ({ icon: Icon, title, subtitle, badges, onClick }: LinkedEntityCardProps) => {
  const content = (
    <>
      <div className="bg-muted flex h-10 w-10 shrink-0 items-center justify-center rounded-md">
        <Icon className="text-muted-foreground h-5 w-5" />
      </div>
      <div className="flex-1 space-y-1">
        <div className="flex flex-wrap items-center gap-2">
          <Typography variant="body" className="font-medium">
            {title}
          </Typography>
          {badges?.map((badge) => {
            const BadgeIcon = badge.icon;

            return (
              <Badge key={badge.label} variant="outline" className="text-xs">
                {BadgeIcon && <BadgeIcon className="mr-1 h-3 w-3" />}
                {badge.label}
              </Badge>
            );
          })}
        </div>
        {subtitle && (
          <Typography variant="caption" className="text-muted-foreground font-mono">
            {subtitle}
          </Typography>
        )}
      </div>
      <ChevronRight className="text-muted-foreground/60 group-hover:text-muted-foreground h-4 w-4 transition-colors" />
    </>
  );

  if (!onClick) {
    return (
      <Card>
        <div className="group flex w-full items-center gap-4 px-6 py-4 text-left">{content}</div>
      </Card>
    );
  }

  return (
    <Card>
      <button
        type="button"
        onClick={onClick}
        className="hover:bg-muted/50 focus-visible:bg-muted/50 group flex w-full items-center gap-4 px-6 py-4 text-left transition-colors focus-visible:outline-none"
      >
        {content}
      </button>
    </Card>
  );
};
